var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfinite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 1.1001H5.25C3.17893 1.1001 1.5 2.77903 1.5 4.8501C1.5 6.92117 3.17893 8.6001 5.25 8.6001H6.75C8.82107 8.6001 10.5 6.92117 10.5 4.8501M12.375 8.6001H12.75C14.8211 8.6001 16.5 6.92117 16.5 4.8501C16.5 2.77903 14.8211 1.1001 12.75 1.1001H11.25C9.17893 1.1001 7.5 2.77903 7.5 4.8501",
    stroke: "#1943DC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinite);
export default __webpack_public_path__ + "static/media/infinite.76e51ea87798b7fa847ee0a9b9beb7ec.svg";
export { ForwardRef as ReactComponent };